export default __webpack_public_path__ + "static/media/oc-logo.e62adc55.svg";